import styled from "styled-components";

export const SettingsMenu = styled.div`
  margin-top: 56px;
`;
